import { cn } from '@/lib/utils';

interface SectionLabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export function SectionLabel({
  className,
  children,
  ...props
}: SectionLabelProps) {
  return (
    <span
      className={cn(
        'text-text-3 text-xs font-medium tracking-wider uppercase',
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
